export const awards_free_reviews_rules = {
  'image_upload': [20, 35, 47],
  'photo_album': [4, 6, 11],
  'video_link': [4, 6, 11]
}

export const awards_reviews_prices = {
  'br': {
    'image_upload': 1400,
    'photo_album': 3500,
    'video_link': 4500
  },
  'ex': {
    'image_upload': 700,
    'photo_album': 1500,
    'video_link': 2100
  }
}

export const awards_open_a_dispute_prices = {
  'br': {
    'image_upload': 2800,
    'photo_album': 7000,
    'video_link': 9000
  },
  'ex': {
    'image_upload': 1400,
    'photo_album': 3000,
    'video_link': 4200
  }
}

export const confirmed_status = ['free', 'paid', 'completed', 'succeeded']

export const annuityRegularPrice = {
  br: 69700,
  ex: 19800
}
